module.exports = __webpack_public_path__ + "static/media/snapshift-6.a03692e4.png";